module.exports = __webpack_public_path__ + "static/media/yashind-problem2.85141bcb.png";